export default {
  title: 'Allergenen',
  options: {
    dairy: 'Zuivel/Melk',
    eggs: 'Eieren',
    fish: 'Vis',
    gluten: 'Gluten',
    mango: 'Mango',
    peanuts: "Pinda's",
    sesame: 'Sesam',
    shellfish: 'Schelpdieren',
    soy: 'Soja',
    tree_nuts: 'Boomnoten',
    celery: 'Selderij',
    crustaceans: 'Schaaldieren',
    lupin: 'Lupine',
    molluscs: 'Weekdieren',
    mustard: 'Mosterd',
    nuts: 'Noten',
    sulphites: 'Sulfieten',
    almonds: 'Amandelen',
    barley: 'Gerst',
    brazil_nuts: 'Paranoten',
    cashew: 'Cashewnoten',
    hazelnuts: 'Hazelnoten',
    kamut: 'Kamut',
    macadamia: 'Macadamianoten',
    oats: 'Haver',
    pecan: 'Pecannoten',
    pistachios: 'Pistachenoten',
    rye: 'Rogge',
    spelt: 'Spelt',
    walnuts: 'Walnoten',
    wheat: 'Tarwe',
    sugared_drink: 'Gesuikerde drank',
    lentils: 'Linzen',
    queensland_nuts: 'Queenslandnoten',
  },
};
